// blakfy-cookie/src/i18n/translations/tr.js — Turkish translations

export default {
  title: "Çerez Tercihleri",
  intro:
    "Bu site, deneyiminizi geliştirmek için çerezler kullanır. Detaylar için Çerez Politikamızı inceleyin.",
  policyLink: "Çerez Politikası",
  acceptAll: "Tümünü Kabul Et",
  rejectAll: "Tümünü Reddet",
  preferences: "Tercihler",
  save: "Seçimleri Kaydet",
  close: "Kapat",
  cat: {
    essential: {
      title: "Zorunlu Çerezler",
      desc: "Sitenin temel işlevleri için gerekli, devre dışı bırakılamaz.",
      always: "Her zaman aktif",
    },
    analytics: {
      title: "Analitik Çerezler",
      desc: "Anonim ziyaret istatistikleri toplama amacıyla kullanılır.",
    },
    marketing: {
      title: "Pazarlama Çerezleri",
      desc: "Kişiselleştirilmiş reklam ve yeniden hedefleme için kullanılır.",
    },
    functional: {
      title: "Fonksiyonel Çerezler",
      desc: "Dil, tema, bölge gibi tercihlerinizi hatırlamak için kullanılır.",
    },
  },
  placeholder: {
    title: "İçerik engellendi",
    desc: "Bu içeriği görmek için {category} çerezlerine izin vermeniz gerekiyor.",
    cta: "İzin ver",
  },
  tabs: {
    categories: "Kategoriler",
    services: "Hizmetler",
    about: "Hakkında",
  },
  service: {
    description: "Açıklama",
    processor: "Veri İşleyici",
    address: "Adres",
    dpo: "VKO İletişim",
    purposes: "Amaçlar",
    technologies: "Kullanılan Teknolojiler",
    dataCollected: "Toplanan Veriler",
    legalBasis: "Hukuki Dayanak",
    retention: "Saklama Süresi",
    transferCountries: "Aktarım Ülkeleri",
    privacyPolicy: "Gizlilik Politikası",
    cookiePolicy: "Çerez Politikası",
    legalBasisValues: {
      consent: "Açık Rıza (GDPR Madde 6/1-a)",
      legitimate_interest: "Meşru Menfaat (GDPR Madde 6/1-f)",
    },
    noServices: "Bu site için henüz hizmet yapılandırılmamış.",
  },
  svcAbout: {
    title: "Bu CMP Hakkında",
    description:
      "Bu web sitesi; GDPR, KVKK, CCPA ve diğer geçerli gizlilik mevzuatlarına uyum sağlamak amacıyla rıza tercihlerinizi yönetmek için Blakfy Çerez Yönetim Platformu'nu (CMP) kullanmaktadır.",
    version: "Sürüm",
    learnMore: "blakfy.com'da daha fazla bilgi",
  },
};
